import React from "react";

import {
  type ModalContentProps,
  ModalContent,
  ModalOverlay,
  ModalCloseButton,
} from "ui/Modal";

// `layout` defaults to "right sidebar", so callers wanting a sidebar can omit it.
// Kept discriminated (per the ModalContentProps members) so `width` stays
// available only for the right-sidebar layout.
type ModalContainerProps = (
  | (Omit<
      Extract<ModalContentProps, { layout: "right sidebar" }>,
      "heading" | "layout"
    > & { layout?: "right sidebar" })
  | (Omit<
      Extract<ModalContentProps, { layout: "centered" }>,
      "heading" | "layout"
    > & { layout: "centered" })
) & { onClose: () => void };

const ModalContainer = ({
  title,
  onClose,
  children,
  ...rest
}: ModalContainerProps) => {
  const heading = (
    <div className="flex space-between bg-[#f7fafc] text-[#606060] border-b border-solid border-[#e8e8ee] text-lg leading-9 pl-4 flex-shrink-0">
      <span className="w-full inline-flex items-center overflow-hidden text-ellipsis">
        {title}
      </span>
      <ModalCloseButton className="float-right text-lg p-3" />
    </div>
  );
  return (
    <ModalOverlay onDismiss={onClose}>
      {rest.layout === "centered" ? (
        <ModalContent
          {...rest}
          layout="centered"
          title={title}
          heading={heading}
        >
          {children}
        </ModalContent>
      ) : (
        <ModalContent
          {...rest}
          layout="right sidebar"
          title={title}
          heading={heading}
        >
          {children}
        </ModalContent>
      )}
    </ModalOverlay>
  );
};

export default ModalContainer;
